module.exports = __webpack_public_path__ + "static/media/price-books-discount .d79bb65a.png";